module.exports = __webpack_public_path__ + "static/media/trae.9092eabe.jpg";